'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = exports.invertLuminance = exports.createColors = undefined;

var _polished = require('polished');

var names = ['red', // 0
'orange', // 30
'yellow', // 60
'lime', // 90
'green', // 120
'teal', // 150
'cyan', // 180
'blue', // 210
'indigo', // 240
'violet', // 270
'fuchsia', // 300
'pink', // 330
'red'];

var hueName = function hueName(h) {
  var i = Math.round((h - 2) / 30);
  var name = names[i];
  return name;
};

var createHues = function createHues(h) {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function (n) {
    return Math.floor((h + n * 360 / 12) % 360);
  });
};

var createColors = exports.createColors = function createColors(base) {
  var colors = {
    black: '#000',
    white: '#fff',
    darken: 'rgba(0, 0, 0, 0.25)',
    gray: '#eee'
  };

  var _parseToHsl = (0, _polished.parseToHsl)(base),
      hue = _parseToHsl.hue,
      saturation = _parseToHsl.saturation,
      lightness = _parseToHsl.lightness;

  var hues = createHues(hue);
  hues.forEach(function (h) {
    var name = hueName(h);
    colors[name] = (0, _polished.hsl)(h, saturation, lightness);
  });

  return colors;
};

var invertLuminance = exports.invertLuminance = function invertLuminance(base) {
  var luminance = (0, _polished.getLuminance)(base);

  var _parseToHsl2 = (0, _polished.parseToHsl)(base),
      hue = _parseToHsl2.hue,
      saturation = _parseToHsl2.saturation;

  return (0, _polished.hsl)(hue, saturation, 1 - luminance);
};

var colors = exports.colors = createColors('#06e');

exports.default = colors;